<template>
  <div class="lightbox" v-if="showLightbox">
    <div class="lightbox-close" @mousedown.stop="hide" @touchdown.stop="hide">
      &times;
    </div>
    <div
      v-if="prevImage"
      class="lightbox-arrow lightbox-arrow-left"
      @mousedown.stop="prev"
      @touchdown.stop="prev"
    >
      <transition name="lightbox-fade">
        <div class="lightbox-arrow-left-icon">
          <svg
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="rgba(20, 20, 20, 0.8)" />
            <path
              d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
              fill="white"
            />
            <path d="M0-.5h24v24H0z" fill="none" />
          </svg>
        </div>
      </transition>
    </div>
    <div
      v-if="nextImage"
      class="lightbox-arrow lightbox-arrow-right"
      @mousedown.stop="next"
      @touchdown.stop="next"
    >
      <transition name="lightbox-fade">
        <div class="lightbox-arrow-right-icon">
          <svg
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="rgba(20, 20, 20, 0.8)" />
            <path
              d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
              fill="white"
            />
            <path d="M0-.25h24v24H0z" fill="none" />
          </svg>
        </div>
      </transition>
    </div>
    <transition name="lightbox-slide-next" mode="out-in">
      <img :src="currentImage" alt="rizes house halkidiki" />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'LightBox',
  props: {
    showLightbox: {
      type: Boolean,
      default: false,
    },
    images: {
      type: Array,
      required: true,
    },
    startAt: {
      type: Number,
    },
  },
  data() {
    return {
      currentImage: this.images[this.startAt],
      currentIndx: 0,
      nextImage: true,
      prevImage: true,
    };
  },
  methods: {
    hide() {
      this.$emit('hideLightbox');
      this.nextImage = true;
    },
    hasNext() {
      if (this.currentIndx + 1 < this.images.length) {
        this.nextImage = true;
        return true;
      } else {
        this.nextImage = false;
        return false;
      }
    },
    hasPrev() {
      if (this.currentIndx - 1 >= 0) {
        this.prevImage = true;
        return true;
      } else {
        this.prevImage = false;
        return false;
      }
    },
    next() {
      this.prevImage = true;
      if (this.hasNext()) {
        this.currentIndx += 1;
        this.currentImage = this.images[this.currentIndx];
      }
    },
    prev() {
      this.nextImage = true;
      if (this.hasPrev()) {
        this.currentIndx -= 1;
        this.currentImage = this.images[this.currentIndx];
      }
    },
  },
  computed: {
    // currentImage() {
    //   return this.images[this.startAt];
    // },
  },
  watch: {
    startAt(val) {
      this.currentImage = this.images[val];
      this.currentIndx = this.startAt;
    },
  },
  components: {},
};
</script>

<style scoped lang="scss">
.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  width: 100%;
  height: 100%;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.8);

  .lightbox-close {
    position: fixed;
    z-index: 210;
    right: 0;
    top: 0;
    padding: 10px;
    font-size: 20px;
    cursor: pointer;
    width: 40px;
    height: 40px;
    color: white;
  }

  .lightbox-arrow {
    padding: 0 20px;
    cursor: pointer;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    padding: 0 20px;
    height: 100%;
    width: 20px;
    z-index: 100;
  }

  .lightbox-arrow-right {
    right: 0;
  }

  .lightbox-arrow-left {
    left: 0;
  }
}

.lightbox-slide-next-enter-active,
.lightbox-slide-next-leave-active,
.lightbox-slide-prev-enter-active,
.lightbox-slide-prev-leave-active {
  transition: all 0.4s ease;
}

.lightbox-slide-next-enter {
  -webkit-transform: translateX(100px);
  -ms-transform: translateX(100px);
  transform: translateX(100px);
  opacity: 0;
}

.lightbox-slide-next-leave-to {
  -webkit-transform: translateX(-100px);
  -ms-transform: translateX(-100px);
  transform: translateX(-100px);
  opacity: 0;
}

.lightbox-fade-enter-active,
.lightbox-fade-leave-active {
  transition: all 0.4s ease;
}
.lightbox-fade-enter,
.lightbox-fade-leave-to {
  opacity: 0;
}

// @media (max-width: 900px) {

// }
</style>
